import api from "./api";

/**
 * Saves a file from an authenticated API endpoint (e.g. an invoice PDF) —
 * a plain link can't send the bearer token, so fetch it and hand the
 * browser a blob.
 */
export async function downloadFile(path, filename) {
  const { data } = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export const downloadInvoicePdf = (invoice, scope = "owner/billing") =>
  downloadFile(`/${scope}/invoices/${invoice.id}/pdf`, `SHUWA-${invoice.number}.pdf`);
